export default "__VITE_ASSET__CHb6iBaR__"